import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, ViewController, AlertController, LoadingController } from 'ionic-angular';
import { AbstractControl, ValidationErrors, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Country } from '../../models/country';
import { User } from '../../providers/user';
import { TranslateService } from '@ngx-translate/core';
import { Countries } from '../../providers/providers';

/**
 * Generated class for the PracticeSignupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  name: 'register',
  segment: 'register',
})
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {

  currentItems: Country[];
  account: { firstname: string, lastname: string, email: string, profession: string, password: string, confirm_password: string, title: string, terms_cond: boolean} = {
    firstname: '',
    lastname: '',
    email: '',
    profession: '1',
    password: '',
    confirm_password: '',
    title: '2',
    terms_cond: false
  };

  submitClient: boolean = false;
  isReadyToSave: boolean;

  credentials: { username: string, password: string } = {
    username: '',
    password: ''
  };

  item: any;
  responseData : any;

  form: FormGroup;

  constructor(public navCtrl: NavController, public user: User, public toastCtrl: ToastController,
    public translateService: TranslateService, formBuilder: FormBuilder, public viewCtrl: ViewController,
    public items: Countries, public alertCtrl: AlertController, public navParams: NavParams, public loading: LoadingController) {

    this.currentItems = this.items.query();
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.form = formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', this.emailOrEmpty],
      profession_id: ['', Validators.required],
      password: ['', Validators.compose([Validators.minLength(10), Validators.required])],
      confirm_password: ['', Validators.compose([Validators.minLength(10), Validators.required])],
      title_id: ['2'],
      country_id: ['13'],
      terms_cond: [false, Validators.requiredTrue]
    }, { validator: this.matchingPasswords('password', 'confirm_password') });

    // Watch the form for changes, and
    this.form.valueChanges.map((val) => {
      // remove the trailing spaces from first name and last name
      val.first_name = val.first_name.trim();
      val.last_name = val.last_name.trim();
      return val;
    })
      .subscribe((v) => {
        this.isReadyToSave = this.form.valid;
      });

  }

  matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
    return (group: FormGroup): { [key: string]: any } => {
      let password = group.controls[passwordKey];
      let confirmPassword = group.controls[confirmPasswordKey];

      if (password.value !== confirmPassword.value) {
        return {
          mismatchedPasswords: true
        };
      }
    }
  }



  onCountryChange(selectedValue: any) {
    let restrictedCountries = ["16", "19", "22", "38", "52", "55", "138", "226"]
    if (restrictedCountries.indexOf(selectedValue) > 0) {
      this.isReadyToSave = false;
      this.presentAlert()
    }
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      subTitle: 'Unfortunately NovoPysch is not available in your country. North American users can gain access via betterworldhealthcare.com',
      buttons: ['Ok']
    });
    alert.present();
  }

  done() {
    if (!this.form.valid) { return; }
    this.doSignup(this.form.value);
  }

  doSignup(formValue: any) {
    if (formValue) {
      let loading = this.loading.create({ spinner: 'hide', content: `<img src="assets/images/Loading.gif" />`, duration: 5000, cssClass: 'activity-detail-loading', showBackdrop: false, dismissOnPageChange: true });
      //loading.present().then(() => {
      loading.present();
      this.user.signup(formValue).subscribe((resp) => {
        if (resp) {
          loading.dismissAll();
          this.responseData = resp.json().data.user;
          this.credentials.username = formValue.email
          this.credentials.password = formValue.password
          this.navCtrl.push('payment-details', { clientId: this.responseData.id, plan: "pro", credentials: this.credentials, price: "$204", duration: "yearly" });
        } else {
          loading.dismissAll();
        }

      }, (err) => {
        // Unable to sign up
        let message = "Unable to create account. Please check your account information and try again."
        if(err.json().meta){
          if(err.json().meta.feedback.length > 1){
            message = err.json().meta.feedback[1].message
          }          
        }
        loading.dismissAll();
        let toast = this.toastCtrl.create({
          message: message,
          duration: 10000,
          position: 'top',
          cssClass: "toast",
        });
        toast.present();
      });
      //});
    }
  }

  openTerms() {
    window.open("https://novopsych.com/terms-conditions-privacy/", "_blank", "location=true");
  }

  emailOrEmpty(control: AbstractControl): ValidationErrors | null {
    return control.value === '' ? null : Validators.email(control);
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts